angular.module('dnecom')
    .controller('MockupProcessDetailsController', ["$scope", "$http", "notifications", function MockupProcessDetailsController($scope, $http, notifications) {
        $scope.categories = [];
        $scope.loadingCategories = false;

        $scope.products = [];
        $scope.loadingProducts = false;
        $scope.loadingProductInfo = false;

        $scope.init = function() {
            if ($scope.mockup.provider) {
                $scope.updateCategories();
                $scope.updateProducts();
            }
        };

        $scope.onProviderChange = function() {
            $scope.mockup.productType = null;
            $scope.products = [];
            $scope.mockup.productId = null;
            $scope.updateCategories();
        };

        $scope.onProductTypeChange = function() {
            $scope.updateProducts();
        };

        $scope.isCategorySelectorVisible = function() {
            return $scope.mockup.provider && $scope.categories.length > 0 && !$scope.loadingCategories;
        };

        $scope.updateCategories = function() {
            if (!$scope.mockup.provider) {
                $scope.categories = [];
                return;
            }

            $scope.loadingCategories = true;

            $http.post(
                Routing.generate('mockup_get_categories'),
                {
                    'accountId': $scope.mockup.provider
                }
            ).then(function(response) {
                $scope.loadingCategories = false;

                if (!response.data.success) {
                    notifications.danger(response.data.message || 'Failed to load product types.');
                    return;
                }

                $scope.categories = response.data.categories;

                if (!$scope.categories.length) {
                    $scope.updateProducts();
                }
            }, function(response) {
                notifications.danger('Invalid server response.');
                $scope.loadingCategories = false;
            });
        };

        $scope.updateProducts = function() {
            $scope.products = [];

            if ($scope.categories.length && !$scope.mockup.productType) {
                return;
            }

            $scope.loadingProducts = true;

            $http.post(
                Routing.generate('mockup_get_products'),
                {
                    'accountId': $scope.mockup.provider,
                    'categoryId': $scope.mockup.productType
                }
            ).then(function(response) {
                if (!response.data.success) {
                    notifications.danger(response.data.message || 'Failed to load design types.');
                    return;
                }

                $scope.products = response.data.products;
                $scope.loadingProducts = false;
            }, function(response) {
                notifications.danger('Invalid server response.');
                $scope.loadingProducts = false;
            });
        };

        $scope.selectProduct = function(product) {
            $scope.mockup.productId = product.id;
            $scope.mockup.properties.selectedColors = [];
            $scope.mockup.properties.previewColor = null;

            $http.post(
                Routing.generate('mockup_get_product'),
                {
                    'accountId': $scope.mockup.provider,
                    'productId': $scope.mockup.productId
                }
            ).then(function(response) {
                $scope.loadingProductInfo = false;

                if (!response.data.success) {
                    return showProductError(response.data.message || 'Failed to load product info.');
                }

                if (!response.data.product) {
                    return showProductError('Product is currently not available at provider\'s store.');
                }

                if (!response.data.product.colors || !response.data.product.colors.length) {
                    return showProductError('Product has no colors defined.');
                }

                $scope.mockup.product = response.data.product;
                $scope.mockup.description = response.data.product.description;
                $scope.mockup.properties.sizes = angular.copy(response.data.product.colors[0].sizes);
            }, function(response) {
                notifications.danger('Invalid server response.');
                $scope.loadingProductInfo = false;
            });
        };

        var showProductError = function(message) {
            $scope.mockup.productId = null;
            notifications.danger(message);
        };
    }]);
